import { trackEvent as internalTrackEvent } from "@/lib/tracker";
import { fireAdsConversion } from "@/lib/ads-conversion";

export function getUTM() {
  try {
    return JSON.parse(sessionStorage.getItem("fs_utm") || "{}");
  } catch {
    return {};
  }
}

export function buildWhatsAppUrl(phone = "5218116289267", message = "") {
  const base = `https://api.whatsapp.com/send?phone=${phone}`;
  if (!message) return base;
  return `${base}&text=${encodeURIComponent(message)}`;
}

// Eventos que nuestro backend acepta como event_type "puro" (sin prefijo custom).
const NATIVE_EVENTS = new Set([
  "page_view",
  "lead_submit",
  "catalog_download",
  "whatsapp_click",
  "phone_click",
  "cta_click",
  "form_open",
  "form_abandon",
  "section_view",
]);

// Mapeo de eventos a tipos de conversión de Google Ads (usando las 4 labels configurables).
const ADS_CONVERSION_MAP = {
  lead_submit: "form",
  form_submit: "form",
  catalog_download: "catalog",
  catalog_form_submitted: "catalog",
  whatsapp_click: "whatsapp",
  phone_click: "phone",
};

/**
 * Unifica el tracking:
 * 1) Envía el evento a GA4 / GTM (dataLayer) si están disponibles.
 * 2) Envía además el evento a nuestro tracker interno (/api/events) para
 *    analítica propia independiente de GA4.
 * 3) Dispara la conversión de Google Ads cuando el evento coincide con uno
 *    de los 4 tipos configurables (form, catalog, whatsapp, phone).
 */
export function trackEvent(event, data = {}) {
  try {
    if (window.gtag) window.gtag("event", event, data);
    if (window.dataLayer) window.dataLayer.push({ event, ...data });
  } catch {}
  try {
    const eventType = NATIVE_EVENTS.has(event) ? event : `custom:${event}`;
    internalTrackEvent(eventType, data);
  } catch {}
  try {
    const conversionType = ADS_CONVERSION_MAP[event];
    if (conversionType) {
      fireAdsConversion(conversionType, { event_label: event, ...data });
    }
  } catch {}
  // eslint-disable-next-line no-console
  console.log("[track]", event, data);
}
